const selectors = {
    el: '.js-show-more:not(.is-initialized)',
    btn: '.js-show-more-btn',
    item: '.js-show-more-item',
    list: '.js-show-more-list'
}

const classes = {
    hidden: 'is-hidden',
}

const loadContent = (el, list) => {
    const items = list.querySelectorAll(selectors.item);

    items.forEach(item => {
        item.classList.remove(classes.hidden);
    });

    requestAnimationFrame(() => {
        list.style.height = list.scrollHeight + 'px';
    });
}

const init = () => {
    const els = document.querySelectorAll(selectors.el);
    els.forEach(el => {
        el.classList.add('is-initialized');
        const btn = el.querySelector(selectors.btn);
        const list = el.querySelector(selectors.list);
        if (!btn || !list) return;

        list.style.height = list.offsetHeight + 'px';

        window.addEventListener('resize', () => {
            list.style.height = '';
            requestAnimationFrame(() => {
                list.style.height = list.offsetHeight + 'px';
            });
        });

        btn.addEventListener('click', () => {
            loadContent(el, list);
            btn.remove();
        });
    });
};

const module = () => {
    init();
    document.addEventListener('domUpdated', init);
};

export default module;